"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var DefaultTheme_1 = require("../../themes/DefaultTheme");
var ProgressiveImage_1 = require("./ProgressiveImage");
exports.StyledSliderImage = styled_components_1["default"].img(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var SliderImage = styled_components_1["default"](ProgressiveImage_1.ProgressiveImage)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    opacity: ", ";\n    transition: 0.5s ease-in-out;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n"], ["\n    opacity: ", ";\n    transition: 0.5s ease-in-out;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: center;\n"])), function (_a) {
    var isActive = _a.isActive;
    return isActive ? "1" : "0";
});
var Slider = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n    height: ", ";\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"], ["\n    position: relative;\n    height: ", ";\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"])), function (props) { return props.height; });
var Header = styled_components_1["default"].h1(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin: 0;\n    font-family: 'Oswald';\n    font-size: ", ";\n    position: absolute;\n    color: #fff;\n    text-transform: uppercase;\n    text-shadow: -5px 1px 20px #000;\n    z-index: 1;\n"], ["\n    margin: 0;\n    font-family: 'Oswald';\n    font-size: ", ";\n    position: absolute;\n    color: #fff;\n    text-transform: uppercase;\n    text-shadow: -5px 1px 20px #000;\n    z-index: 1;\n"])), DefaultTheme_1.DefaultTheme.Spacing[6]);
exports.ImageSlider = function (_a) {
    var slideDuration = _a.slideDuration, images = _a.images, header = _a.header, height = _a.height, imageQuality = _a.imageQuality, imageTransformations = _a.imageTransformations;
    var _b = react_1.useState(0), currentIndex = _b[0], setCurrentIndex = _b[1];
    var nextSlide = function () {
        var newIndex = currentIndex + 1 === images.length ? 0 : currentIndex + 1;
        setCurrentIndex(newIndex);
    };
    react_1.useEffect(function () {
        var interval = setInterval(nextSlide, slideDuration);
        return (function () {
            clearInterval(interval);
        });
    }, [nextSlide, slideDuration]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Slider, { height: height ? height + "px" : "100vh" },
            header ? (React.createElement(Header, null, header)) : React.Fragment,
            images.map(function (img, index) {
                return React.createElement(SliderImage, { filters: imageTransformations.filters, size: imageTransformations.size, src: img, key: img, isActive: currentIndex === index });
            }),
            ";")));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
